import { z } from 'zod';
// daysToDeadline = vatClaimDeadline − today (calendar days). <0 past, 0..30 soon.
export function agingBucket(daysToDeadline) {
    if (daysToDeadline < 0)
        return 'OVERDUE';
    if (daysToDeadline <= 30)
        return 'APPROACHING';
    return 'OK';
}
export const RequestVatWriteOffSchema = z.object({
    apBillId: z.uuid(),
    writeOffDate: z.coerce.date(),
    reason: z.string().max(500).optional(),
});
export const VatSuspenseRowSchema = z.object({
    apBillId: z.uuid(),
    voucherNo: z.string(),
    vendorName: z.string(),
    vatAmount: z.number(),
    billDate: z.coerce.date(),
    vatClaimDeadline: z.coerce.date().nullable(),
    daysToDeadline: z.number().int().nullable(),
    bucket: z.enum(['OK', 'APPROACHING', 'OVERDUE']).nullable(),
    hasOpenRequest: z.boolean(),
});
//# sourceMappingURL=vat-writeoff.js.map